// Component: Quote
// Author: Jay
import * as React from 'react';
import QuoteNPM from '@rotaryintl/component-quote';
import { Text, Image } from '@sitecore-jss/sitecore-jss-react';

export default function Quote(props) {
  const isEditing = props.sitecoreContext && props.sitecoreContext.pageEditing;
  return (
    <>
      {isEditing || props.fields?.Quote?.value ? (
        <QuoteNPM
          text={<Text field={props.fields?.Quote} />}
          authorName={props.fields?.Author?.fields?.Name?.value}
          authorTitle={props.fields?.Author?.fields?.Title?.value}
          authorImg={<Image field={props.fields?.Author?.fields?.Image} editable={false} />}
        ></QuoteNPM>
      ) : null}
    </>
  );
}
